export default __webpack_public_path__ + "static/media/gather.0ef530a8.mp4";